<page-loader *ngIf="!isLoaded"></page-loader>
<ng-container *ngIf="isLoaded">
    <div class="form-wrapper-80">
        <div class="app-c-form-group">
            <label class="app-c-form--label" for="orgId">Organization</label>
            <select
                class="app-c-form-control"
                id="orgId"
                [(ngModel)]="orgId"
                (ngModelChange)="onSelectOrganization({ value: $event })">
                <option [value]="null">Select an organization to edit the resources</option>
                <option *ngFor="let org of organizations" [value]="org.id">
                    {{ org.name }}
                </option>
            </select>
        </div>
    </div>

    <ng-container *ngIf="orgId">
        <resources-edit
            [resources]="organization"
            [updatedData]="updatedData"
            (onResourceSetChange)="resourceSetChanged($event)">
        </resources-edit>

        <div class="form-wrapper-80 form-actions">
            <p class="error-message" *ngIf="errors">{{ errors }}</p>
            <button tabindex="0" class="app-c-btn app-c-btn--primary app-c-btn--curve" (click)="doSave()">
                Save
            </button>
        </div>
    </ng-container>
</ng-container>
